var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.347,
    height: 65.335,
    viewBox: "0 0 65.347 65.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_046-shopping",
    "data-name": "046-shopping",
    d: "M46.7,55.172H26.925A15.33,15.33,0,0,1,11.613,39.859v-15.7A23.218,23.218,0,0,0,1.148,4.728,2.552,2.552,0,1,1,3.957.467,28.365,28.365,0,0,1,12.9,9.931a14.568,14.568,0,0,0,10.45,4.534H52.741A12.625,12.625,0,0,1,64.939,30.1L61.556,43.585A15.293,15.293,0,0,1,46.7,55.172ZM16.073,18.127a28.516,28.516,0,0,1,.644,6.036v15.7A10.22,10.22,0,0,0,26.925,50.067H46.7a10.2,10.2,0,0,0,9.9-7.724l3.383-13.484a7.5,7.5,0,0,0-7.247-9.29H23.352a19.027,19.027,0,0,1-7.279-1.442ZM25.649,62.19a3.19,3.19,0,1,0-3.19,3.19,3.19,3.19,0,0,0,3.19-3.19Zm25.394,0a3.19,3.19,0,1,0-3.19,3.19,3.19,3.19,0,0,0,3.19-3.19Zm4.25-34.964a2.552,2.552,0,0,0-2.552-2.552H24.373a2.552,2.552,0,0,0,0,5.1H52.741A2.552,2.552,0,0,0,55.294,27.226Z",
    transform: "translate(0 -0.045)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProduct);
export default __webpack_public_path__ + "static/media/ic_product.099d8b4337c1574e53625d9e5d9d8242.svg";
export { ForwardRef as ReactComponent };